import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
} from "@material-ui/core/";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { useSelector, useDispatch } from "react-redux";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import registerStyle from "./registerItems.module.css";
import logo from "../../../assests/authLogo.png";
import { registerRequest } from "../../../reduxSlices/registerSlice";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import SnackBar from "../../SnackBar";
import config from "../../../app/config";
import { isObjectEmpty } from "../../../utils/general";
import localizedStrings from "../../../utils/localize";
import { parseISO } from "date-fns";

const useStyle = makeStyles((theme) => ({
  container: {
    margin: "0",
    padding: "1rem 0",
  },
  itemContainer: {
    background: "red",
    margin: "0 auto",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  logoAvatar: {
    width: "30%",
    height: "auto",
  },
  bottomContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
  },
  datepicker: {
    width: "100%",
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  datepickerContainer: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiIconButton-root": {
      color: "red",
    },
  },
}));

const RegisterItems = (props) => {
  const classes = useStyle(props);

  const registerRequestData = useSelector(
    (state) => state.resgisterRequest.registerRequestData,
  );
  const errorMessage = useSelector(
    (state) => state.resgisterRequest.errorMessage,
  );
  const dispatch = useDispatch();
  const [displayMessage, setDisplayMessage] = useState("");

  if (registerRequestData.token !== undefined) {
    dispatch(clearLoginData());
    // window.localStorage.removeItem("x-auth-token");
    // window.localStorage.removeItem("x-auth-fullname");
    // window.localStorage.removeItem("x-auth-contactId");
    // window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    window.localStorage.setItem("x-auth-token", registerRequestData.token);
    props.history.push({
      pathname: "/prospective/landingpage",
      state: { isRegister: true },
    });
  }
  const dataFetchingStatus = useSelector(
    (state) => state.resgisterRequest.dataFetchingStatus,
  );

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  const [registerData, setregisterData] = useState({
    form: {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
      password: "",
    },
  });

  const [confirmPassword, setConfirmPssword] = useState("");
  const [check, setcheck] = useState(false);
  const [checkconfirmPassword, setcheckconfirmPassword] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);

  let emailExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const textFieldChangeHandler = (event) => {
    const formData = { ...registerData.form };

    if (event.target.name === "email") {
      setIsValidEmail(!emailExp.test(event.target.value.trim()));
    }

    formData[event.target.name] = event.target.value.trim();
    setregisterData({
      form: formData,
    });
  };
  const confirmPasswordChangeHandler = (event) => {
    setConfirmPssword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let passwordMatch = registerData.form.password;
    if (passwordMatch.search(/[a-z]/) < 0) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = `${localizedStrings.general.passwordhaslowercase}`;
      return setShowSnackBar(status);
    }
    if (passwordMatch.search(/[A-Z]/) < 0) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = `${localizedStrings.general.passwordhasuppercase}`;
      return setShowSnackBar(status);
    }
    if (passwordMatch.search(/[0-9]/) < 0) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = `${localizedStrings.general.passwordnumber}`;
      return setShowSnackBar(status);
    }
    if (passwordMatch.length >= 25) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = `${localizedStrings.general.passwordlengthmax}`;
      return setShowSnackBar(status);
    }
    if (!(registerData.form.password === confirmPassword)) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = `${localizedStrings.general.confirmpassword}`;
      setShowSnackBar(status);
    } else {
      window.localStorage.setItem("email", registerData.form.email);
      window.localStorage.setItem("password", registerData.form.password);
      dispatch(registerRequest(registerData.form));
    }
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = errorMessage.error;
      setShowSnackBar(status);
    }
  }, [errorMessage]);

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };
  const [labelName, setLabelName] = useState({
    firstName: localizedStrings.register.firstName,
    lastName: localizedStrings.register.lastName,
    email: localizedStrings.register.email,
    password: localizedStrings.register.password,
    confirmPassword: localizedStrings.register.confirmPassword,
  });
  const [passwordErrorMsg, setPasswordErrorMsg] = useState(
    localizedStrings.register.passwordErrorMsg,
  );
  const [checkPasswordformat, setcheckPasswordformat] = useState(
    localizedStrings.general.passwordcontains,
  );
  const [emailErrorMsg, setEmailPasswordMsg] = useState(
    localizedStrings.general.invalidemail,
  );
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
    setLabelName({
      firstName: localizedStrings.register.firstName,
      lastName: localizedStrings.register.lastName,
      email: localizedStrings.register.email,
      password: localizedStrings.register.password,
      confirmPassword: localizedStrings.register.confirmPassword,
    });

    setPasswordErrorMsg(localizedStrings.register.passwordErrorMsg);
    setEmailPasswordMsg(localizedStrings.general.invalidemail);
  }, [language]);

  const isValidBirthdate = (date) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(date)) {
      return false; // Invalid format
    }
    const today = new Date();
    const birthdateObj = new Date(date);
    return birthdateObj < today; // Ensure birthdate is in the past
  };

  useEffect(() => {
    const isFormValid = Object.entries(registerData.form).every(
      ([key, value]) => {
        if (key === "dateOfBirth") {
          return value !== null && isValidBirthdate(value);
        }
        return typeof value === "string" && value.trim() !== "";
      },
    );

    setIsValid(isFormValid);

    let passwordMatch = registerData.form.password;
    if (passwordMatch != "") {
      if (
        passwordMatch.search(/[a-z]/) < 0 ||
        passwordMatch.search(/[A-Z]/) < 0 ||
        passwordMatch.search(/[0-9]/) < 0 ||
        passwordMatch?.length < 8
      ) {
        setcheckPasswordformat(localizedStrings.general.passwordcontains);
        setcheck(true);
      } else {
        setcheck(false);
      }
    }
    if (confirmPassword != "") {
      if (registerData.form.password != confirmPassword) {
        setcheckconfirmPassword(true);
      } else {
        setcheckconfirmPassword(false);
      }
    }
  }, [registerData, confirmPassword]);
  useEffect(() => {
    if (
      showSnackBar.message ===
      "User Already Exists,try login with your email Id"
    ) {
      setDisplayMessage(localizedStrings.general.userexistserrorMessage);
    } else if (showSnackBar.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(showSnackBar.message);
    }
  }, [showSnackBar]);

  const handelDateChangeEditable = (date, value, eventName) => {
    const formData = { ...registerData.form };
    formData[eventName] = value === null ? "" : value;
    setregisterData({
      form: formData,
    });
  };

  return (
    <Aux>
      <SnackBar
        open={showSnackBar.status}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <div className={registerStyle.registerContainer}>
        <div className={registerStyle.registerContent}>
          <div className={classes.logoAvatar}>
            <img src={logo} width="100%" alt="Eslsca logo" />
          </div>

          <Typography component="h1" variant="h5">
            {localizedStrings.register.register}
          </Typography>

          <Typography style={{ fontSize: "15px" }}>
            Si tu étudies présentement à l’USB, utiliser ton compte @monusb.ca{" "}
            <a href={`${config.BASE_URL}/login`}>ici</a>. Si tu suis un cours à
            double reconnaissance de crédits à l’USB comme élève du secondaire
            ou si tu suis un cours en jeune enfance hors programme, tu tombes
            aussi dans cette catégorie.
          </Typography>

          <form className={classes.form} onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              name="firstName"
              value={registerData.form.firstName}
              onChange={(e) => {
                textFieldChangeHandler(e);

                // Show custom validation message if the input is too short
                if (e.target.value.length < 2) {
                  e.target.setCustomValidity(
                    `${localizedStrings.register.helpermsg}`,
                  );
                } else {
                  e.target.setCustomValidity(""); // Clear the custom message when valid
                }
              }}
              label={labelName.firstName}
              autoComplete="first-name"
              color="secondary"
              InputProps={{
                endAdornment: <AccountBoxIcon style={{ color: "#959595" }} />,
              }}
              inputProps={{
                maxLength: 100,
                minLength: 2,
              }}
            />
            <TextField
              margin="normal"
              fullWidth
              type="text"
              name="lastName"
              value={registerData.form.lastName}
              onChange={(e) => {
                textFieldChangeHandler(e);

                // Show custom validation message if the input is too short
                if (e.target.value.length < 2) {
                  e.target.setCustomValidity(
                    `${localizedStrings.register.helpermsg}`,
                  );
                } else {
                  e.target.setCustomValidity(""); // Clear the custom message when valid
                }
              }}
              label={labelName.lastName}
              autoComplete="last-name"
              color="secondary"
              InputProps={{
                endAdornment: <AccountBoxIcon style={{ color: "#959595" }} />,
              }}
              inputProps={{
                maxLength: 100,
                minLength: 2,
              }}
            />

            <MuiPickersUtilsProvider libInstance={moment} utils={DateFnsUtils}>
              <div className={classes.datepickerContainer}>
                <label
                  htmlFor="Date of Birth *"
                  style={{ fontSize: "12px", color: "#0000008a" }}
                >
                  {localizedStrings.applicationpage.dateOfBirth}
                  <div style={{ fontSize: "12px", color: "#0000008a" }}>
                    {localizedStrings.applicationpage.yearmonthdate}
                  </div>
                </label>
                <KeyboardDatePicker
                  margin="normal"
                  format="yyyy-MM-dd"
                  value={
                    registerData.form.dateOfBirth === ""
                      ? null
                      : parseISO(registerData.form.dateOfBirth)
                  }
                  error={false}
                  helperText={null}
                  onChange={(date, value) =>
                    handelDateChangeEditable(date, value, "dateOfBirth")
                  }
                  className={classes.datepicker}
                />
              </div>
            </MuiPickersUtilsProvider>

            <TextField
              margin="normal"
              fullWidth
              type="email"
              name="email"
              value={registerData.form.email}
              onChange={textFieldChangeHandler}
              label={labelName.email}
              autoComplete="email"
              color="secondary"
              InputProps={{
                endAdornment: <MailOutlineIcon style={{ color: "#959595" }} />,
              }}
              inputProps={{
                maxLength: 100,
              }}
            />
            {isValidEmail && (
              <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
                {emailErrorMsg}
              </Typography>
            )}
            <TextField
              margin="normal"
              fullWidth
              name="password"
              value={registerData.form.password}
              onChange={textFieldChangeHandler}
              label={labelName.password}
              type="password"
              autoComplete="current-password"
              color="secondary"
              InputProps={{
                endAdornment: <LockOutlinedIcon style={{ color: "#959595" }} />,
              }}
              inputProps={{
                maxLength: 25,
                minLength: 8,
              }}
            />
            <TextField
              margin="normal"
              fullWidth
              name="confirmPassword"
              label={labelName.confirmPassword}
              type="password"
              autoComplete="current-password"
              color="secondary"
              onChange={confirmPasswordChangeHandler}
              value={confirmPassword}
              InputProps={{
                endAdornment: <LockOutlinedIcon style={{ color: "#959595" }} />,
              }}
              inputProps={{
                maxLength: 25,
                minLength: 8,
              }}
              error={checkconfirmPassword === true || check === true}
              // error={registerData.form.password !== confirmPassword}
              helperText={
                check === true
                  ? checkPasswordformat
                  : checkconfirmPassword === true
                    ? passwordErrorMsg
                    : ""
              }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              style={{
                backgroundColor: !isValid ? "#808080ad" : "#0b9ec1",
                color: "#ffffff",
              }}
              className={classes.submit}
              disabled={!isValid}
            >
              {localizedStrings.register.submityourregistration}
            </Button>
            <Grid container className={classes.bottomContainer}>
              <Typography>
                <span> {localizedStrings.register.signUpMessage}</span>
                <Link
                  variant="body2"
                  style={{ cursor: "pointer", marginLeft: "4px" }}
                  onClick={() => {
                    props.history.push("/login");
                  }}
                >
                  {localizedStrings.register.signIn}
                </Link>
              </Typography>
            </Grid>
          </form>
        </div>
      </div>
    </Aux>
  );
};

export default RegisterItems;
